import React, { useCallback, useEffect, useState } from 'react';
import { DataGrid, GridOverlay, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import { getStickeringAssets } from '../../services/asset.service';
import Box from '@mui/material/Box';
import * as CryptoJS from "crypto-js";
import StickerPasteStatusPopupBox from "../../atoms/StickerPasteStatusPopupBox";
import { Pagination } from "@mui/material";
import Select from "react-select";
import * as XLSX from 'xlsx';
import '../ExcelUploads/AssetInfo/AssetList.css';
import '../ExcelUploads/AssetInfo/DataGridStyles.css';

/* ─── Date Helpers (unchanged) ─── */
Date.prototype.dbFormatedDate = function () {
    let year = this.getFullYear();
    let month = this.getMonth() + 1;
    let day = this.getDate();
    if (month < 10) month = '0' + month;
    if (day < 10) day = '0' + day;
    return year + '-' + month + '-' + day;
}

function getFormatedDate(dateString) {
    if (!dateString) return null;
    let dte = new Date(dateString);
    if (isNaN(dte.getTime())) return String(dateString);
    let year = dte.getFullYear();
    let month = String(dte.getMonth() + 1).padStart(2, '0');
    let day = String(dte.getDate()).padStart(2, '0');
    let hours = String(dte.getHours()).padStart(2, '0');
    let minutes = String(dte.getMinutes()).padStart(2, '0');
    let seconds = String(dte.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

function CustomToolbar({ items }) {
    const handleExportExcel = () => {
        if (!items || !items.length) return;
        const exportData = items.map((row, idx) => ({
            'Sl No': idx + 1,
            'TAG': row.tag || '',
            'Parent TAG': row.parent_tag || '',
            'Status of QR Sticker': row.qr_paste_status !== 'N' ? 'Pasted' : 'Not Pasted',
            'Date of Addition': getFormatedDate(row.created_at) || ''
        }));
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Stickering Status');
        XLSX.writeFile(workbook, 'Stickering_Status_List.xlsx');
    };

    return (
        <GridToolbarContainer style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 16px' }}>
            {/*<GridToolbarExport
                csvOptions={{
                    fileName: 'Stickering_Status_List',
                    allColumns: true,
                    getRowsToExport: (params) => params.apiRef.current.getAllRowIds()
                }}
                printOptions={{
                    getRowsToExport: (params) => params.apiRef.current.getAllRowIds()
                }}
            />*/}
            <button
                type="button"
                onClick={handleExportExcel}
                className="btn btn-sm btn-outline-success"
                style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontWeight: 600, borderRadius: '6px', padding: '4px 12px' }}
            >
                <i className="bi bi-file-earmark-excel-fill"></i> Export to Excel (.xlsx)
            </button>
        </GridToolbarContainer>
    );
}

const CustomLoader = () => (
    <GridOverlay style={{ background: 'rgba(255, 255, 255, 0.75)', backdropFilter: 'blur(3px)', zIndex: 10 }}>
        <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
            <CircularProgress color="primary" size={36} thickness={4} />
            <span style={{ fontSize: '13px', fontWeight: 600, color: '#334155' }}>Loading Stickering Status Data...</span>
        </Box>
    </GridOverlay>
);

function StickeringStatusList() {
    /* ─── All State (unchanged) ─── */
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [pageSize, setPageSize] = useState(50);
    const [tag, setTag] = useState('');
    const [qrPasteStatus, setQrPasteStatus] = useState('');
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);

    /* ─── Columns (backend unchanged – enhanced styling) ─── */
    const columns = [
        { field: "sl_no", hideable: true, hide: true, editable: false, headerName: "Sl No", width: 50 },
        {
            field: "tag", editable: false, hide: false, headerName: "TAG", width: 250,
            valueGetter: (params) => params.row.tag || '',
            renderCell: (params) => {
                let EncryptID = CryptoJS.AES.encrypt(JSON.stringify({
                    'tag': params.row.tag, 'back_url': 'stickering-status'
                }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
                return <a className="al-cell-tag-link" href={`/asset-basic-details?tag=${EncryptID}`}><i className="bi bi-tag-fill"></i> {params.value}</a>;
            }
        },
        { field: "parent_tag", hideable: true, hide: true, editable: true, headerName: "Parent TAG", width: 250 },
        {
            field: "qr_paste_status", editable: true, hide: false, headerName: "Status of QR Sticker", width: 230,
            valueGetter: (params) => params.row.qr_paste_status !== 'N' ? 'Pasted' : 'Not Pasted',
            renderCell: (params) => {
                const isPasted = params.row.qr_paste_status !== 'N';
                return (
                    <div
                        className={`al-status-badge ${isPasted ? 'al-status-success' : 'al-status-danger'} al-status-clickable`}
                        onClick={() => handleConfirmOpen(params.row.qr_paste_status, params.row.tag)}
                    >
                        <i className={`bi ${isPasted ? 'bi-check-circle-fill' : 'bi-x-circle-fill'}`} />
                        {isPasted ? 'Pasted' : 'Not Pasted'}
                    </div>
                );
            }
        },
        {
            field: "created_at", editable: true, hide: false, headerName: "Date of Addition", width: 180,
            valueGetter: (params) => getFormatedDate(params.row.created_at),
            renderCell: (params) => <p style={{ margin: 0 }}>{getFormatedDate(params.row.created_at)}</p>
        },
    ];

    const calculateOffset = (page, pageSize) => (page - 1) * pageSize;

    /* ─── Fetch Assets (unchanged logic) ─── */
    const fetchAssets = useCallback(async () => {
        setLoading(true);
        const offset = calculateOffset(page, pageSize);
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify({
            param_data: { 'offset': offset, 'pageSize': pageSize },
            authToken: sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();

        try {
            const res = await getStickeringAssets({ token: encryptedData });
            if (res?.data?.data?.length) {
                setItems(res.data.data);
                setTotalItems(res.data.total || 0);
            } else {
                setItems([]);
            }
        } catch (error) {
            console.error('Error fetching assets:', error);
            setItems([]);
        } finally {
            setLoading(false);
        }
    }, [page, pageSize]);

    useEffect(() => {
        fetchAssets();
    }, [fetchAssets]);

    const handlePageSizeChange = (value) => {
        setPageSize(value);
        setPage(1);
    };

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const totalPages = Math.ceil(totalItems / pageSize);

    const handleConfirmClose = () => {
        fetchAssets();
        setIsConfirmOpen(false);
    };

    const handleConfirmOpen = async (qr_paste_status, tag) => {
        setQrPasteStatus(qr_paste_status);
        setTag(tag);
        setIsConfirmOpen(true);
    };

    /* ─── RENDER ─── */
    return (
        <div className="al-page" id="stickering-status-page">

            {/* ══ PAGE HEADER ══ */}
            <div className="al-page-header" id="al-page-header">
                <div className="al-page-header-left">
                    <div className="al-page-header-icon">
                        <i className="bi bi-qr-code-scan" />
                    </div>
                    <div className="al-page-header-text">
                        <h5 className="al-page-title">Stickering Status List</h5>
                        <p className="al-page-subtitle">Track QR sticker application status for assets</p>
                    </div>
                </div>
                {!loading && items.length > 0 && (
                    <div className="al-record-badge" id="al-record-badge">
                        <i className="bi bi-layers-fill" />
                        <strong>{totalItems.toLocaleString('en-IN')}</strong>&nbsp;Total Assets
                    </div>
                )}
            </div>

            {/* ══ DATA GRID CARD ══ */}
            <div className="al-grid-card" id="al-grid-card">
                <div className="al-grid-card-header">
                    <span className="al-grid-card-title">
                        <i className="bi bi-table" /> Stickering Records
                    </span>
                    {!loading && items.length > 0 && (
                        <span className="al-showing-badge">
                            Showing <strong>{items.length}</strong> of <strong>{totalItems.toLocaleString('en-IN')}</strong>
                        </span>
                    )}
                </div>

                <Box>
                    {loading && items.length === 0 ? (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '70px 20px', gap: '14px', background: '#ffffff', borderRadius: '0 0 16px 16px' }}>
                            <CircularProgress size={42} thickness={4} style={{ color: '#0284c7' }} />
                            <p style={{ margin: 0, fontSize: '14px', fontWeight: 600, color: '#334155' }}>Loading Stickering Status Data...</p>
                            <span style={{ fontSize: '12px', color: '#94a3b8' }}>Please wait while we retrieve the records</span>
                        </div>
                    ) : (
                        <DataGrid
                            rows={items}
                            getRowId={(row, index) => row.sl_no || row.tag || index}
                            columns={columns}
                            autoHeight
                            className="al-data-grid"
                            components={{
                                LoadingOverlay: CustomLoader,
                                Toolbar: CustomToolbar,
                                Pagination: () => (
                                    <Box className="al-pagination-bar">
                                        <div className="al-page-size-row">
                                            <span className="al-page-size-label">Rows per page</span>
                                            <Select
                                                options={[
                                                    { value: 50, label: '50' },
                                                    { value: 100, label: '100' },
                                                    { value: 200, label: '200' },
                                                    { value: 500, label: '500' },
                                                ]}
                                                value={{ value: pageSize, label: pageSize.toString() }}
                                                onChange={(selected) => handlePageSizeChange(selected.value)}
                                                classNamePrefix="al-select"
                                                menuPlacement="top"
                                                styles={{ container: (base) => ({ ...base, minWidth: 80 }) }}
                                            />
                                        </div>
                                        <Pagination
                                            count={totalPages}
                                            page={page}
                                            onChange={handlePageChange}
                                            variant="outlined"
                                            shape="rounded"
                                            size="small"
                                        />
                                    </Box>
                                ),
                            }}
                            componentsProps={{
                                toolbar: { items: Array.isArray(items) ? items : [] }
                            }}
                            loading={loading}
                        />
                    )}
                </Box>
            </div>

            {/* ══ STICKER STATUS MODAL (unchanged) ══ */}
            <StickerPasteStatusPopupBox
                qrPasteStatus={qrPasteStatus}
                tag={tag}
                isOpen={isConfirmOpen}
                onClose={handleConfirmClose}
            />
        </div>
    )
}

export default StickeringStatusList